// extracted by mini-css-extract-plugin
export default {"wrapper":"popupGroupLayoutStyles_wrapper__ktkFo","popupSlot":"popupGroupLayoutStyles_popupSlot__c6qxT","popupSlot__up":"popupGroupLayoutStyles_popupSlot__up__X67-Q"};